var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2BD684"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0442 10.6925C11.0442 10.5821 11.1337 10.4925 11.2442 10.4925H12.7552C12.8657 10.4925 12.9552 10.5821 12.9552 10.6925V17.9368C12.9552 18.0473 12.8657 18.1368 12.7552 18.1368H11.2442C11.1337 18.1368 11.0442 18.0473 11.0442 17.9368V10.6925ZM10.7734 7.89665C10.7734 7.58875 10.8849 7.32332 11.1079 7.10036C11.3415 6.86679 11.6334 6.75 11.9838 6.75C12.3341 6.75 12.6261 6.86148 12.8597 7.08444C13.1039 7.29678 13.226 7.56752 13.226 7.89665C13.226 8.22577 13.1039 8.50182 12.8597 8.72478C12.6261 8.93712 12.3341 9.04329 11.9838 9.04329C11.6334 9.04329 11.3415 8.93181 11.1079 8.70885C10.8849 8.47528 10.7734 8.20454 10.7734 7.89665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question_icon.1107ed3713c29c411fac60989e0b8503.svg";
export { ForwardRef as ReactComponent };